<div class="container landing-container listing-page-wrapper">
    <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" class="breadcrumb-block d-none d-lg-block">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Sydney</li>
            <li class="breadcrumb-item" aria-current="page">Restaurants</li>
        </ol>
    </nav>
    <div class="row">
        <div class="col-lg order-1 order-lg-0">
            <div class="view-change-wrap d-md-none">
                <ul>
                    <li>
                        <button class="btn btn-icon" (click)="toggleLineView()" [ngClass]="gridView ? '' : 'active'">
                            <img src="./assets/images/ic-grid-view.svg" alt="Icon">
                        </button>
                    </li>
                    <li>
                        <button class="btn btn-icon" (click)="toggleGridView()" [ngClass]="gridView ? 'active' : ''">
                            <img src="./assets/images/ic-line-view.svg" alt="Icon">
                        </button>
                    </li>
                </ul>
            </div>
            <div class="restaurants-tab-outer main-layout" [ngClass]="gridView ? 'grid-view' : ''">
                <ul ngbNav #dishNav="ngbNav" [(activeId)]="activePanel" class="nav-tabs">
                    <li [ngbNavItem]="1">
                        <button ngbNavLink>Popular</button>
                        <ng-template ngbNavContent>
                            <div class="restro-details-wrap" (scroll)="onRestroScroll()">
                                <div class="row">
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block" (click)="openRestroContentModal(restroContent)">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">1.</span>
                                                        <span>
                                                            Hunter & Barrel
                                                        </span>
                                                        <span class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                    <li>Top 20 places</li>
                                                </ul>
                                                <ul class="other-info d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block" (click)="openRestroContentModal(restroContent)">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">
                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">2.</span>
                                                        <span>Social Brew Cafe</span>
                                                        <span class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block" (click)="openRestroContentModal(restroContent)">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">3.</span> Mr.Wong <span class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block" (click)="openRestroContentModal(restroContent)">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">4.</span> Pendolino<span class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block" (click)="openRestroContentModal(restroContent)">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">5.</span>Dead Ringer <span
                                                            class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2">
                        <button ngbNavLink>Open Now</button>
                        <ng-template ngbNavContent>
                            <div class="restro-details-wrap">
                                <div class="row">
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">4.</span> Pendolino<span class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">5.</span>Dead Ringer <span
                                                            class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="3">
                        <button ngbNavLink>Delivery</button>
                        <ng-template ngbNavContent>
                            <div class="restro-details-wrap">
                                <div class="row">
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block" (click)="openRestroContentModal(restroContent)">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">1.</span> Hunter & Barrel <span
                                                            class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                    <li>Top 20 places</li>
                                                </ul>
                                                <ul class="other-info d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block" (click)="openRestroContentModal(restroContent)">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">
                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">2.</span> Social Brew Cafe <span
                                                            class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">3.</span> Mr.Wong <span class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="4">
                        <button ngbNavLink>Nearby</button>
                        <ng-template ngbNavContent>
                            <div class="restro-details-wrap">
                                <div class="row">
                                    <div [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'">
                                        <div class="restro-block">
                                            <img src="./assets/images/restaurant-1.jpg" alt="Restaurant"
                                                class="restro-view">

                                            <div class="restro-block-inner">
                                                <div class="inner-head">
                                                    <h4 class="restro-title">
                                                        <span class="count">3.</span> Mr.Wong <span class="status">open
                                                            now</span>
                                                    </h4>
                                                    <div class="ratig-inner">
                                                        <h5 class="ratings">4.3</h5>
                                                        <span class="rating-icon">
                                                            <img src="./assets/images/ic-primary-rating.svg"
                                                                alt="Rating">
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="key-points"
                                                    [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
                                                    <li>Australian</li>
                                                    <li>Chinese</li>
                                                    <li>$34-$85</li>
                                                </ul>
                                                <ul class="other-info  d-none d-md-block">
                                                    <li>
                                                        <img src="./assets/images/ic-clock-primary-light.svg"
                                                            alt="Icon">
                                                        <span>Wed - Fri,
                                                            11:30 AM - 2:30 PM</span>
                                                    </li>
                                                    <li>
                                                        <img src="./assets/images/ic-location.svg" alt="Icon">
                                                        <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                                            Australia</span>
                                                    </li>
                                                </ul>
                                                <div class="cuisines-count-wrap d-md-none"
                                                    [ngClass]="{'d-none': !gridView}">
                                                    <div class="cuisines-count">4 cuisines</div>
                                                    <h5 class="price">~$56</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="dishNav" class="mt-2"></div>
            </div>
        </div>
        <div class="col-lg-6 order-0 order-lg-1 location-col">
            <div class="location-finder-wrap">
                <div class="search-wrap" [class.view-searchbar]="isSearchBarActive">
                    <div class="form-group">
                        <div class="location-chip d-none d-md-flex">
                            <img src="./assets/images/ic-location.svg" alt="Icon">
                            <h6>Sydney</h6>
                        </div>
                        <input class="form-control" type="search" placeholder="Search" aria-label="Search" />
                        <div class="btn-grps">
                            <button class="btn btn-clear-search d-none">
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
                                        fill="currentcolor" />
                                </svg>
                            </button>
                            <!-- <button class=" btn btn-scan btn-view">
                                        <div class="svg-wrap">
                                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M0 9.33333V0H9.33333V9.33333H0ZM3.5 3.5V5.83333H5.83333V3.5H3.5ZM11.6667 9.33333V0H21V9.33333H11.6667ZM15.1667 3.5V5.83333H17.5V3.5H15.1667ZM0 11.6667V21H9.33333V11.6667H0ZM5.83333 15.1667V17.5H3.5V15.1667H5.83333ZM15.1667 11.6667H11.6667V14H15.1667V18.6667H14V16.3333H11.6667V21H16.3333V18.6667H18.6667V21H21V17.5H18.6667V16.3333H17.5V15.1667H21V11.6667H17.5V14H15.1667V11.6667Z"
                                                    fill="currentcolor" />
                                            </svg>
                                        </div>
                            </button> -->
                            <div ngbDropdown placement="bottom-end" #myDrop="ngbDropdown" class="f-drop-wrap">
                                <button class="btn btn-filter btn-view" id="dropdown-filter" ngbDropdownToggle>
                                    <div class="svg-wrap mod-svg-wrap">
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1.05485 2.10499C0.828945 2.10499 0.603042 2.18919 0.420168 2.32601C-0.0531511 2.68386 -0.139209 3.34693 0.226538 3.7995V3.81003L5.93864 10.967V17.2714L8.40206 19.6921C8.82159 20.1026 9.51005 20.1026 9.92959 19.6921C10.3491 19.2817 10.3491 18.6081 9.92959 18.1976L8.0901 16.4084V10.2408L1.92619 2.51546C1.8232 2.38586 1.69094 2.28136 1.53977 2.21014C1.38859 2.13893 1.22262 2.10293 1.05485 2.10499ZM14.5445 9.47244V17.7661C14.5875 18.0818 14.4799 18.4186 14.2325 18.6397C14.133 18.7372 14.0148 18.8146 13.8846 18.8674C13.7545 18.9203 13.615 18.9474 13.4741 18.9474C13.3332 18.9474 13.1937 18.9203 13.0636 18.8674C12.9334 18.8146 12.8152 18.7372 12.7157 18.6397L10.5535 16.5241C10.4362 16.4119 10.347 16.2747 10.2929 16.1231C10.2387 15.9716 10.2212 15.8099 10.2415 15.6506V9.47244H10.2093L4.01309 1.70504C3.8384 1.48563 3.75958 1.20748 3.79385 0.931383C3.82811 0.655284 3.97268 0.40368 4.19597 0.231549C4.40036 0.0841995 4.62626 0 4.86292 0H19.9231C20.1597 0 20.3856 0.0841995 20.59 0.231549C20.8133 0.40368 20.9579 0.655284 20.9922 0.931383C21.0264 1.20748 20.9476 1.48563 20.7729 1.70504L14.5767 9.47244H14.5445Z"
                                                fill="currentcolor" />
                                            <circle cx="17" cy="17" r="6" fill="#FAF8FA" />
                                            <path d="M13 16H16V13H18V16H21V18H18V21H16V18H13V16Z" fill="#AE77A0" />
                                        </svg>
                                    </div>
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdown-filter" class="filter-dropdown">
                                    <div class="filter-chips-wrap d-none d-md-flex">
                                        <div class="chips-inner">
                                            <div class="chip">
                                                <span>Lunch</span>
                                                <button class="btn">
                                                    <img src="./assets/images/ic-close.svg" alt="Icon">
                                                </button>
                                            </div>
                                            <div class="chip">
                                                <span>Breakfast</span>
                                                <button class="btn">
                                                    <img src="./assets/images/ic-close.svg" alt="Icon">
                                                </button>
                                            </div>
                                            <div class="chip">
                                                <span>Dinner</span>
                                                <button class="btn">
                                                    <img src="./assets/images/ic-close.svg" alt="Icon">
                                                </button>
                                            </div>
                                            <div class="chip">
                                                <span>Supper</span>
                                                <button class="btn">
                                                    <img src="./assets/images/ic-close.svg" alt="Icon">
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-wrapper">
                                        <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills outer-tabs">
                                            <ng-container ngbNavItem="place">
                                                <button ngbNavLink>Place</button>
                                                <ng-template ngbNavContent>
                                                    <div class="inner-tab-block">
                                                        <div ngbNav #nav="ngbNav" [(activeId)]="activeInner"
                                                            class="nav-tabs">
                                                            <ng-container ngbNavItem="by-rating">
                                                                <button ngbNavLink>
                                                                    <img src="./assets/images/ic-tab-arrow.svg"
                                                                        alt="Icon" />
                                                                    By Rating
                                                                </button>
                                                                <ng-template ngbNavContent>
                                                                    <p>By Rating Content</p>
                                                                </ng-template>
                                                            </ng-container>
                                                            <ng-container ngbNavItem="price-range">
                                                                <button ngbNavLink>
                                                                    <img src="./assets/images/ic-tab-arrow.svg"
                                                                        alt="Icon" />
                                                                    Price Range
                                                                </button>
                                                                <ng-template ngbNavContent>
                                                                    <p>Price Range Content</p>
                                                                </ng-template>
                                                            </ng-container>
                                                            <ng-container ngbNavItem="type-of-meal">
                                                                <button ngbNavLink>
                                                                    <img src="./assets/images/ic-tab-arrow.svg"
                                                                        alt="Icon" />
                                                                    Type of Meal
                                                                </button>
                                                                <ng-template ngbNavContent>
                                                                    <div class="checkbox-wrap-row">
                                                                        <div class="row">
                                                                            <div class="col-12">
                                                                                <div class="form-check">
                                                                                    <input type="checkbox"
                                                                                        class="form-check-input"
                                                                                        id="breakfastCheck" checked />
                                                                                    <label class="form-check-label"
                                                                                        for="breakfastCheck">
                                                                                        Breakfast
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-12">
                                                                                <div class="form-check">
                                                                                    <input type="checkbox"
                                                                                        class="form-check-input"
                                                                                        id="lunchCheck" />
                                                                                    <label class="form-check-label"
                                                                                        for="lunchCheck">
                                                                                        Lunch
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-12">
                                                                                <div class="form-check">
                                                                                    <input type="checkbox"
                                                                                        class="form-check-input"
                                                                                        id="dinnerCheck" />
                                                                                    <label class="form-check-label"
                                                                                        for="dinnerCheck">
                                                                                        Dinner
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-12">
                                                                                <div class="form-check">
                                                                                    <input type="checkbox"
                                                                                        class="form-check-input"
                                                                                        id="supperCheck" />
                                                                                    <label class="form-check-label"
                                                                                        for="supperCheck">
                                                                                        Supper
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </ng-template>
                                                            </ng-container>
                                                        </div>

                                                        <div [ngbNavOutlet]="nav"></div>
                                                    </div>
                                                </ng-template>
                                            </ng-container>
                                            <ng-container ngbNavItem="categories">
                                                <button ngbNavLink>Categories</button>
                                                <ng-template ngbNavContent>
                                                    <div class="child-tab-content">
                                                        <p>Data 2</p>
                                                    </div>
                                                </ng-template>
                                            </ng-container>
                                        </div>
                                        <div [ngbNavOutlet]="nav" class="outer-tab-content"></div>
                                    </div>
                                    <div class="filter-chips-wrap d-md-none">
                                        <div class="chips-inner">
                                            <div class="chip">
                                                <span>Lunch</span>
                                                <button class="btn">
                                                    <img src="./assets/images/ic-close.svg" alt="Icon">
                                                </button>
                                            </div>
                                            <div class="chip">
                                                <span>Breakfast</span>
                                                <button class="btn">
                                                    <img src="./assets/images/ic-close.svg" alt="Icon">
                                                </button>
                                            </div>
                                            <div class="chip">
                                                <span>Dinner</span>
                                                <button class="btn">
                                                    <img src="./assets/images/ic-close.svg" alt="Icon">
                                                </button>
                                            </div>
                                            <div class="chip">
                                                <span>Supper</span>
                                                <button class="btn">
                                                    <img src="./assets/images/ic-close.svg" alt="Icon">
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cta-btn-wrap d-md-none">
                                        <button class="btn btn-outline-primary with-icon">
                                            <div class="svg-wrap">
                                                <svg width="12" height="14" viewBox="0 0 12 14" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 8.484 10.1067 11.0867 6.4 13.8667C6.2846 13.9532 6.14425 14 6 14C5.85575 14 5.7154 13.9532 5.6 13.8667C1.89333 11.0867 0 8.484 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0ZM6 4C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6C8 5.46957 7.78929 4.96086 7.41421 4.58579C7.03914 4.21071 6.53043 4 6 4Z"
                                                        fill="currentcolor" />
                                                </svg>
                                            </div>
                                            Sydney
                                        </button>
                                        <button class="btn btn-outline-primary">Open</button>
                                        <button class="btn btn-outline-primary" disabled>
                                            Closeby
                                        </button>
                                        <button class="btn btn-outline-primary with-icon" disabled>
                                            <div class="svg-wrap">
                                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M0 5.77778V0H5.77778V5.77778H0ZM2.16667 2.16667V3.61111H3.61111V2.16667H2.16667ZM7.22222 5.77778V0H13V5.77778H7.22222ZM9.38889 2.16667V3.61111H10.8333V2.16667H9.38889ZM0 7.22222V13H5.77778V7.22222H0ZM3.61111 9.38889V10.8333H2.16667V9.38889H3.61111ZM9.38889 7.22222H7.22222V8.66667H9.38889V11.5556H8.66667V10.1111H7.22222V13H10.1111V11.5556H11.5556V13H13V10.8333H11.5556V10.1111H10.8333V9.38889H13V7.22222H10.8333V8.66667H9.38889V7.22222Z"
                                                        fill="currentcolor" />
                                                </svg>
                                            </div>
                                            Scan
                                        </button>
                                    </div>
                                    <!-- <div class="b-btn-grp">
                                        <button class="btn btn-outline-danger" title="Clear All">
                                            Clear All
                                        </button>
                                        <button class="btn btn-primary" title="Apply">Apply</button>
                                    </div> -->
                                </div>
                            </div>
                            <button class="btn btn-view-text d-none d-md-flex" title="Open">
                                Open
                            </button>
                            <button class="btn btn-view-text d-none d-md-flex" title="Closeby" disabled>
                                Closeby
                            </button>
                            <button class="btn btn-view btn-search" (click)="viewSearchBar()">
                                <div class="svg-wrap" style="margin-top: 1px;">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13 13L10.1667 10.1617L13 13ZM11.7368 6.36842C11.7368 7.79221 11.1712 9.15769 10.1645 10.1645C9.15769 11.1712 7.79221 11.7368 6.36842 11.7368C4.94463 11.7368 3.57915 11.1712 2.57237 10.1645C1.5656 9.15769 1 7.79221 1 6.36842C1 4.94463 1.5656 3.57915 2.57237 2.57237C3.57915 1.5656 4.94463 1 6.36842 1C7.79221 1 9.15769 1.5656 10.1645 2.57237C11.1712 3.57915 11.7368 4.94463 11.7368 6.36842V6.36842Z"
                                            stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
                                    </svg>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="location-map-frame">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.7030329876966!2d72.49795187594992!3d23.03467351587532!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8352e403437b%3A0xdc9d4dae36889fb9!2sTatvaSoft!5e0!3m2!1sen!2sin!4v1706782801389!5m2!1sen!2sin"
                        style="border:0;" allowfullscreen="" loading="lazy" frameBorder="0"
                        referrerpolicy="no-referrer-when-downgrade">
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Restaurant details Modal -->
<ng-template #restroContent let-modal>
    <div class="modal-body">
        <div class="restaurants-tab-outer">
            <div class="restro-block">
                <img src="./assets/images/restaurant-1.jpg" alt="Restaurant" class="restro-view">

                <div class="restro-block-inner">
                    <div class="inner-head">
                        <h4 class="restro-title">
                            <span class="count">1.</span> Hunter & Barrel <span class="status">open
                                now</span>
                        </h4>
                        <div class="ratig-inner">
                            <h5 class="ratings">4.3</h5>
                            <span class="rating-icon">
                                <img src="./assets/images/ic-primary-rating.svg" alt="Rating">
                            </span>
                        </div>
                    </div>
                    <ul class="key-points">
                        <li>Australian</li>
                        <li>Chinese</li>
                        <li>$34-$85</li>
                        <li>Top 20 places</li>
                    </ul>
                    <ul class="other-info">
                        <li>
                            <img src="./assets/images/ic-clock-primary-light.svg" alt="Icon">
                            <span>Wed - Fri,
                                11:30 AM - 2:30 PM</span>
                        </li>
                        <li>
                            <img src="./assets/images/ic-location.svg" alt="Icon">
                            <span>Tenancy 303 Cockle Bay Wharf Sydney New South Wales 2000
                                Australia</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</ng-template>